import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../services/registration.service';
import { SafeHtmlPipe } from '../safe-html.pipe';

@Component({
  templateUrl: './page-not-found.component.html',
  providers: [ SafeHtmlPipe ]
})
export class  pagenotfoundComponent implements OnInit {
  faqs: any;
  safehtml: any;
  registrationFrm: any;
frmService: any;

  constructor(
    private route: ActivatedRoute,
    private RegistrationService:RegistrationService,
    private safeHtml: SafeHtmlPipe
  ) {
    this.safehtml = safeHtml;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: { [x: string]: any; }) => {
      const model = params['model'];
      
      this.RegistrationService.getfaqs(model).subscribe(data => {
        this.faqs = data._result;
      });
    });
  
  }

  sanitizeHtml(value:any) {
    return this.safehtml.transform(value);
  }
   // captcha valu validate validation.
   onCaptchaValidate(isValid: boolean) {
    const field = this.registrationFrm.get('captcha');
    if (!isValid) {
      field?.setErrors({ notValid: true });
    }
  }
}
